import {
  computeMargin,
  computeRatio,
  computeTotalCostByChannel,
  normalizeCompositions,
} from './computeRecipeChannelCost';

import { getProductPriceExcludingVAT } from '@admin/products/products/detail/components/ProductInfo/utils/getProductPriceExcludingVAT.js';

export const computeRecipeChannelPerformance = ({
  compositions,
  recipe,
  associatedProduct,
  channels,
  defaultChannelId,
  numberDecimals,
}) => {
  if (!recipe || !defaultChannelId || !Array.isArray(channels) || channels.length === 0) {
    return {};
  }

  const entities = normalizeCompositions(compositions, channels);

  if (entities.length === 0) {
    const empty = {};

    channels.forEach((channel) => {
      empty[channel.id] = {
        costExTax: null,
        priceExTax: +getProductPriceExcludingVAT(associatedProduct, channel.id) || null,
        marginExTax: null,
        ratio: null,
        margin: null,
      };
    });

    return empty;
  }

  const totalsByChannel = computeTotalCostByChannel(entities, recipe, channels, defaultChannelId);

  const metricsByChannel = {};

  channels.forEach((channel) => {
    const cost = recipe.hasMultipleChannels
      ? totalsByChannel[channel.id]
      : channel.id === defaultChannelId
      ? totalsByChannel[defaultChannelId]
      : null;

    const priceExTax = +getProductPriceExcludingVAT(associatedProduct, channel.id) || null;
    const ratio = computeRatio(cost, channel.id, associatedProduct, numberDecimals);
    const margin = computeMargin(cost, channel.id, associatedProduct, numberDecimals);
    const marginExTax = priceExTax != null && cost != null ? priceExTax - cost : null;

    metricsByChannel[channel.id] = {
      costExTax: cost ?? null,
      priceExTax,
      marginExTax,
      ratio,
      margin,
    };
  });

  return metricsByChannel;
};

export default computeRecipeChannelPerformance;
